// Error code 122 is used for "Access Denied" in the host app
export const ACCESS_DENIED_URL = '/error/accessdenied/122?login=1';
